export default "__VITE_ASSET__TjkLDDtx__"